import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import REST from '../Shared/REST';
import '../assets/custom.css';
import Helpers from "../Shared/Helpers";
import RecordRTC from "recordrtc";
import SafaryWorker from "../Shared/SafariWorker";
import {BUCKET_URL} from "../Shared/Consts";
import lamejs from "lamejs";

import "../assets/students/CopyRight.css";
import LoadingModal from "../LoadingModalComponent/LoadingModal";
import {Buttons, Buttons1, CountDownComponent, LevelTrackerComponent, VideoComponent} from "./Common";
import ProgressBox from "../ProgressModalComponent/ProgressBox";
import recButton from "../assets/images/rec.gif";
import videoInstructionPN from '../assets/images/video_instructions.png';
import videoMaskPN from '../assets/images/video_mask.png';
import DialogBox from "../Shared/DialogBox";
import InstructionModals from "../Shared/InstructionModals";
import {clearInterval, setInterval} from "timers";
import connect from "react-redux/es/connect/connect";
import {updateAppStates, updateStudentAccountTab, updateStudentAppsStatus} from "./actions";
import TRACKING from "../Shared/DataTrackingPoints";

let hasGetUserMedia = false;
try {
    hasGetUserMedia = !!navigator.getUserMedia ||!!navigator.mediaDevices.getUserMedia || !!navigator.webkitGetUserMedia || !!navigator.mozGetUserMedia || !!navigator.msGetUserMedia;
}
catch(err) {
    hasGetUserMedia = !!navigator.getUserMedia || !!navigator.webkitGetUserMedia || !!navigator.mozGetUserMedia || !!navigator.msGetUserMedia ;
}

const instructionVideo = document.getElementById("copyrightInstruction");
let newSes = `{
	"crVideoId": 2,
	"AV_FileName": "",
	"startLevel": 1,
	"endLevel": 0,
	"startProgress": 1,
	"endProgress": 0,
	"guid": "5d1db0ae-f4a7-498f-a445-a2397d99fae2"
}`;
let bestScor = `{
	"success": true,
	"body": {
		"id": 6479,
		"userId": 10020,
		"createdAt": "2018-12-26T15:02:15.338Z",
		"updatedAt": "2018-12-26T15:20:52.996Z",
		"mazeLevel": 1,
		"mazeScore": 1,
		"slashLevel": 1,
		"slashScore": 1,
		"ksLevel": 1,
		"ksScore": 1,
		"pnLevel": 1,
		"pnScore": 1,
		"crLevel": 1,
		"crScore": 1,
		"wssLevel": 1,
		"wssScore": 1,
		"kssLevel": 1,
		"kssScore": 1,
		"deletedAt": null
	},
	"msg": ""
}`;
let copyrightTest = `[{
	"id": 2,
	"createdAt": "2018-10-29T09:54:43.727Z",
	"updatedAt": "2018-10-29T09:54:43.727Z",
	"englishSentence": "I like baseball.",
	"aslSequence": "BASEBALL ME LIKE",
	"aslSigns": "BASEBALL,LIKE",
	"actor": "Regina",
	"x2": null,
	"level": 1,
	"signCount": 2,
	"url": "https://s3.us-east-2.amazonaws.com/uploadbeta/content/copyright/2.mp4",
	"deletedAt": null,
	"cr_assessments": []
}]`;
let objectConstructor = {}.constructor;

class CopyRightComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: 0,
            loadedScores: false,
            bestScores:{
                crScore:1,
                crLevel:1
            }
        };
    }

    async componentDidMount() {
        await Helpers.authorize(this);
        await REST.getBestScores().then(async(response) => {
            if (response.success) {
                await this.setState({
                    loadedScores: true,
                    bestScores:response.body
                });
            }
        });
        await REST.getStudentAppStatus().then(async(res)=>{
            await this.props.updateStudentAppStatus(res.body);
            let {allowedApps, filteredApps, finishedApps} = Helpers.filterApps(this.props.studentUser,this.props.apps);
            await this.props.updateAppStates({
                allowedApps:allowedApps,
                filteredApps:filteredApps,
                finishedApps:finishedApps
            });
            await this.setState({bestScores: res.body.bestScores})
        });
        if(this.props.apps.copyRightScores.filter(function(x){return x.gradingDate==null}).length > 3){
            this.props.history.goBack();
        }
    }

    handleActive = (active) => {
        console.log("handle active");
        console.log(active);
        this.setState({active: active});
    };

    handleBeginTest = () => {
        this.setState({active: 3});
    };

    render() {
        return (
            <div className={this.state.active !== 2 ? "bgGrey CopyRight" : "bgYellow Copyright"}>
                {
                    this.state.active === 0 ?
                        <div>
                            <div className="section appSection bgGrey">
                                <div className="container">
                                    <div className="appContainer progressBox1">
                                        <h1 style={{textAlign: "center",fontSize:'42px'}}>CopyRight</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 text-center"}>
                                                {
                                                    this.state.loadedScores ?
                                                    <ProgressBox
                                                        appName={"copyright"}
                                                        level={this.state.bestScores.crLevel}
                                                        step={this.state.bestScores.crScore}
                                                        steps={3}
                                                        maxLevel={6}
                                                        noDescription
                                                    /> : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons appName={"copyright"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 1 ?
                        <div>
                            <div className={"appSection bgGrey"}>
                                <div className="container">
                                    <Buttons1 demo appName={"copyright"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>

                                    <div className="appContainer copyright">
                                        <h1 style={{textAlign: "center", fontSize:'42px'}}>CopyRight: Show Me</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 centerBlock"}>
                                                <VideoComponent url={"https://s3.us-east-2.amazonaws.com/uploaddev/video/copyright/Copyright_sh.mp4"}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons demo appName={"copyright"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 2 ?
                        <div>
                            <Buttons1 practice appName={"copyright"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                            <Tutorial studentUser={this.props.studentUser} beginTest={this.handleBeginTest}/>
                            <Buttons appName={"copyright"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 3 ?
                        <div>
                            <Buttons1 appName={"copyright"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                            <CopyRight studentUser={this.props.studentUser} buttonClick = {this.handleActive} />
                            <Buttons appName={"copyright"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
            </div>
        )
    }
}


class CopyRight extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showVideo: true,
            popupSurvey: false,
            timerInterval:null,
            timerTime:60,
            sessionTime:60,
            isUploading:false,
            countdown:-1,
            isCounting:false,
            bestScores: null,
            countDownTimer:null,
            videoTimeout:null,
            recordVideo: null,
            rejectedReason: '',
            recording: false,
            crVideoSrc:"",
            crVideoPlayCount:0,
            recordingVideoPlayCount:0,
            recordingAudioPlayCount:0,
            videoSrc: false,
            crPaused:false,
            recordingsCount:0,
            recClick:0,
            audioSrc:false,
            audioBlob:false,
            recordAudio:null,
            audioVideoSwitch:"video",
            modalDialog: false,
            modalInstruction: false,
            responseContent:'',
            upTime: null,
            disableSubmit:false,
            sessionData: {
                crVideoId: 0,
                AV_FileName: "",
                startLevel: 0,
                endLevel: 0,
                startProgress: 0,
                endProgress: 0,
                guid: require('uuid/v4')()
            }
        };
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
        this.handleStartCopyRight = this.handleStartCopyRight.bind(this);
        this.handleShowVideo = this.handleShowVideo.bind(this);
        this.handleStart = this.handleStart.bind(this);
        this.handleStop = this.handleStop.bind(this);
        this.setStreamToVideo = this.setStreamToVideo.bind(this);
        this.releaseStreamFromVideo = this.releaseStreamFromVideo.bind(this);
        this.uploadVideo = this.uploadVideo.bind(this);
        this.requestUserMedia = this.requestUserMedia.bind(this);
        this.startRecord = this.startRecord.bind(this);
        this.stopRecord = this.stopRecord.bind(this);
        this.handleBackToMenu = this.handleBackToMenu.bind(this);
        this.submitSession = this.submitSession.bind(this);
        this.crVideoPause = this.crVideoPause.bind(this);
        this.handlePlay = this.handlePlay.bind(this);
        this.handleSeek = this.handleSeek.bind(this);
        this.handleRecordVideo = this.handleRecordVideo.bind(this);
        this.recordingPlay = this.recordingPlay.bind(this);
        this.toggleAudioVideo = this.toggleAudioVideo.bind(this);
        this.onUnload = this.onUnload.bind(this);
        this.handleToggleInstruction = this.handleToggleInstruction.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    onUnload(event) { // the method that will be used for both add and remove event
        event.returnValue = "By leaving or reloading the page you will lose your app progress"
    }

    async componentDidMount() {
        window.addEventListener("beforeunload", this.onUnload);
        if(/firefox/i.test(navigator.userAgent)){
            this.setState({
                modalDialog: true,
                responseContent: 'Please use Safari or Chrome browser for this task'
            });
            return;
        }
        Helpers.authorize(this);
        if (!hasGetUserMedia) {
            this.setState({
                modalDialog: true,
                responseContent: !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && (navigator.userAgent.match('CriOS') || navigator.userAgent.match('Mozilla')) ? 'Please use Safari (above version 11) for this task.' : 'Your browser cannot stream from your webcam. Please switch to Chrome.'

            });
            return;
        }
        this.requestUserMedia();
        this.handleStartCopyRight();
        await this.setState({
            analytics: {
                type: TRACKING.STUDENT_CR_START,
                metadata: {
                    platform: navigator.platform,
                    userAgent: navigator.userAgent
                }
            }
        })
        this.handleAnalytics();
    };

    componentWillUnmount(){
        window.removeEventListener("beforeunload", this.onUnload);
        if(this.state.recording){
            if(this.state.audioVideoSwitch==="video") {
                this.state.recordVideo.stop(res => {
                    console.log("Component unmount");
                });
            }else{
                this.state.recordAudio.stop(res => {
                    console.log("Component unmount");
                });
            }
            clearInterval(this.state.countDownTimer);
            clearTimeout(this.state.videoTimeout);
            clearInterval(this.state.timerInterval);
            this.captureUserMedia((stream) => {
                stream.stop();
            });
        }
        if(this.video && this.video.srcObject){
            this.video.srcObject.stop();
        }
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleShowVideo(){
        this.setState({showVideo:!this.state.showVideo});
    }

    handleToggleInstruction= (toggleInstruction) => {
        localStorage.setItem('CopyrightInstruction', toggleInstruction);
    }

    handleBackToMenu(e) {
        this.props.history.goBack();
    }

    requestUserMedia() {
        console.log('requestUserMedia');
        this.captureUserMedia((stream) => {
            this.setStreamToVideo(stream);
            console.log('setting state', this.state)
        });
    }

    handleStart(stream) {
        if(this.state.audioVideoSwitch==="video") {
            this.setStreamToVideo(stream);
        }
        console.log('Recording Started.');

        let durationAllowed = 3*this.crVideo.duration;

        let timerInterval = setInterval(() => {
            if(durationAllowed>0) {
                this.setState({
                    timerTime: this.state.timerTime - 1
                });
            }else{
                clearInterval(this.state.timerInterval);
                this.setState({
                    timerInterval: null
                });
            }
        },1000);

        let timeoutTimer = setTimeout(()=>{
          this.stopRecord();
        },1000*3*this.crVideo.duration);

        this.setState({
            recording: true,
            videoTimeout:timeoutTimer,
            timerInterval:timerInterval,
            timerTime:durationAllowed,
            sessionTime:durationAllowed
        });

    }

    handleStop(blob) {
        this.setState({
            recording: false,
            videoTimeout:null,
            timerInterval:null
        });

        if(this.state.audioVideoSwitch==="video") {
            this.releaseStreamFromVideo();
        }else {
            this.releaseStreamFromAudio();
        }
        console.log('Recording Stopped.');

        this.uploadVideo(blob instanceof Blob, blob);
    }

    setStreamToVideo(stream) {
        this.video.srcObject = stream;
    }

    releaseStreamFromVideo() {
        this.video.srcObject = null;
    }

    async encodeMono(channels, sampleRate, samples) {
        let kbps = 256; //encode 128kbps mp3
        let mp3encoder = new lamejs.Mp3Encoder(channels, sampleRate, kbps);
        let sampleBlockSize = 1152; //can be anything but make it a multiple of 576 to make encoders life easier

        let mp3Data = [];
        for (let i = 0; i < samples.length; i += sampleBlockSize) {
            let sampleChunk = samples.subarray(i, i + sampleBlockSize);
            let mp3buf = mp3encoder.encodeBuffer(sampleChunk);
            if (mp3buf.length > 0) {
                mp3Data.push(mp3buf);
            }
        }
        let mp3buf = mp3encoder.flush();   //finish writing mp3

        if (mp3buf.length > 0) {
            mp3Data.push(new Int8Array(mp3buf));
        }
        let blob = new Blob(mp3Data, {type: 'audio/mp3'});
        await this.setState({
            audioBlob:blob
        });
        this.handleStop(blob);
    }

    setStreamToAudio(stream) {
        console.log(stream);
        this.audio.srcObject = stream;
    }

    releaseStreamFromAudio() {
        this.audio.pause();
        this.audio.srcObject = null;
        this.audio.src = "";
        this.audio.load();
    }

    startRecordAudio() {
        this.captureUserMedia((stream) => {
            let options = {
                type: 'audio',
                audio:this.audio,
                sampleRate: 44100,
                bufferSize: 4096,
                numberOfAudioChannels:1,
                recorderType: RecordRTC.StereoAudioRecorder
            };

            this.setState({recordAudio:new RecordRTC.StereoAudioRecorder(stream,options)});
            this.state.recordAudio.record();
            this.handleStartAudio(stream);
        },{audio:true,video:false});
    }

    handleStopAudio(wavBlob) {
        this.setState({
            recording: false
        });

        console.log('Recording Stopped.');

        console.log(wavBlob);

        let fileReader = new FileReader();
        fileReader.onload = (event) => {
            console.log(event);
            let arrayBuffer = event.target.result;
            let wav = lamejs.WavHeader.readHeader(new DataView(arrayBuffer));
            let samples = new Int16Array(arrayBuffer, wav.dataOffset, wav.dataLen / 2);
            this.encodeMono(wav.channels, wav.sampleRate, samples);
            this.releaseStreamFromAudio();
        };
        fileReader.readAsArrayBuffer(wavBlob);
    }

    handleStartAudio(stream) {
        this.setState({
            recording: true
        });

        this.setStreamToAudio(stream);
        this.handleStart(stream);
        console.log('Recording Audio Started.');
    }

    stopRecordAudio() {
        this.state.recordAudio.stop((wavBlob) => {
            this.handleStopAudio(wavBlob);
        });
    }

    async getMediaParam(options){
        let params = null;
        let userAgent = await navigator.userAgent;
        if(options){
            params = options;
        }else if(/Chrome/i.test(userAgent)&&/Windows/i.test(userAgent)){
            params = {
                video:true
            };
        }else{
            params = {
                audio:true,
                video: await Helpers.getVideoSizes()
            };
        }
        return params;
    }

    captureUserMedia = async (callback, options) => {

        let params = null;
        params = await this.getMediaParam(options);
        navigator.mediaDevices.getUserMedia(params)
            .then(callback)
            .catch(error => {
                this.setState({
                    modalDialog: true,
                    responseContent: error
                });
            });
    };

    async uploadVideo(isBlob, blob) {
        const vidETA = await Helpers.calculateETA(null,blob);
        await this.setState({
            upTime: vidETA
        });
        await this.setState({
            analytics: {
                type: TRACKING.STUDENT_CR_UPLOAD_START,
                metadata: {
                    platform: navigator.platform,
                    userAgent: navigator.userAgent,
                    upTime: vidETA
                }
            }
        })
        this.handleAnalytics();
        await this.startTimer();
        await REST.uploadCRVideo(isBlob, blob).then(async(res) => {
            if(this.state.audioVideoSwitch==="video") {
                this.video.src = BUCKET_URL + res.body.filepath;
                await this.setState({
                    videoSrc: this.video.src,
                    recordingsCount: this.state.recordingsCount+1,
                    crVideoPlayCount: 1,
                    isUploading:false
                });
            }else{
                this.audio2.src = BUCKET_URL + res.body.filepath;
                await this.setState({
                    audioSrc: this.audio2.src,
                    recordingsCount: this.state.recordingsCount+1,
                    isUploading:false
                });
                this.audio2.load();
            }
            window.removeEventListener("beforeunload", this.onUnload);
            if(this.state.recordingsCount>1){
                this.submitSession();
            }
        }).catch(error => {
            console.log(error);
        });
    }

    submitSession(){
        this.setState({
            disableSubmit: true
        })
        let seshData = this.state.sessionData;
        if(this.state.audioVideoSwitch === "video") {
            seshData.AV_FileName = this.state.videoSrc.replace(BUCKET_URL, "");
        }else{
            seshData.AV_FileName = this.state.audioSrc.replace(BUCKET_URL, "");
        }
        console.log(seshData);
        if(!this.props.practice) {
            window.removeEventListener("beforeunload", this.onUnload);
            REST.insertCRSession(seshData).then(res => {
                this.setState({
                    modalDialog: true,
                    responseContent:'Data Successfully Saved and Submitted'
                });
                setTimeout(()=>{this.setState({modalDialog:false, popupSurvey: true}); },2500);
                console.log("session created");
                console.log(res);
            });
        }
    }

    async handleSurveyBack(){
        //window.location.reload();
        this.props.buttonClick(0);
    }

    handleStartCopyRight = async () => {
        if(this.props.practice){
            if(typeof newSes !== 'object' && newSes !== null){
                newSes = await JSON.parse(newSes);
            }
            if(typeof bestScor !== 'object' && bestScor !== null){
                bestScor = await JSON.parse(bestScor);
            }
            if(typeof copyrightTest !== 'object' && copyrightTest !== null){
                copyrightTest = await JSON.parse(copyrightTest);
            }
            await this.setState({
                bestScores: bestScor.body,
                sessionData: newSes,
                crVideoSrc:copyrightTest[0].url,
                crVideoPlayCount:0
            });
        }
        else {
            REST.getCRRandom().then(async (res) => {
                let crVideos = res.body;
                let bestScores = await REST.getBestScores();
                let newSesh = this.state.sessionData;
                newSesh.startLevel = bestScores.body.crLevel;
                newSesh.startProgress = bestScores.body.crScore;
                newSesh.crVideoId = crVideos[0].id;
                console.log('Sesh: '+ JSON.stringify(newSesh));
                console.log('Best: '+ JSON.stringify(bestScores));
                console.log('Src: '+ JSON.stringify(crVideos));
                await this.setState({
                    bestScores: bestScores.body,
                    sessionData: newSesh,
                    crVideoSrc:crVideos[0].url,
                    crVideoPlayCount:0
                });
            }).catch(error => {
                console.log(error);
            });
        }
    };

    async handleRecordVideo(){
        await this.setState({isCounting:true});
        if(this.state.recordingsCount<=1) {
            await this.setState({countdown: 3, recClick: this.state.recClick + 1});
            let countDownTimer = setInterval(async () => {
                await this.setState({
                    countdown: this.state.countdown - 1
                });
                if (this.state.countdown < 0) {
                    await this.setState({isCounting:false});
                    clearInterval(countDownTimer);
                    this.startRecord();
                }
            }, 1000);
            await this.setState({
                countDownTimer: countDownTimer
            });
        }
    }

    startRecordVideo() {
        this.captureUserMedia((stream) => {
            let options = {
                type: 'video',
                recorderType: RecordRTC.WhammyRecorder,
                frameInterval: 50,
                video: this.video,
                width: 320,
                height: 240
            };

            this.setState({recordVideo: new SafaryWorker().WhammyRecorder(stream, options)});
            this.state.recordVideo.record();
            this.handleStart(stream);
        });
    }

    stopRecordVideo() {
        this.state.recordVideo.stop((result) => {
            this.handleStop(result);
        });
    }

    stopRecord() {
        if(this.state.audioVideoSwitch==="video"){
            this.stopRecordVideo();
        }else{
            this.stopRecordAudio();
        }
        clearTimeout(this.state.videoTimeout);
        clearInterval(this.state.timerInterval);
        this.setState({
            recording:false,
            isUploading:true
        });
    }

    startRecord() {
        if(this.state.audioVideoSwitch==="video"){
            this.startRecordVideo();
        }else{
            this.startRecordAudio();
        }
        this.setState({
            recording:true
        });
    }

    crVideoPause(pause) {
        this.setState({crPaused: pause});
        if(pause) {
            this.crVideo.pause();
        }else{
            this.crVideo.play();
        }
    }

    handlePlay(){
        let replay = this.state.crPaused===false || this.crVideo.currentTime === 0;
        let vid = document.getElementById("copyrightInstruction");
        vid.playbackRate = 0.7;
        if(!replay){
            this.crVideoPause(false);
        }else{
            this.setState({
                crVideoPlayCount:this.state.crVideoPlayCount+1
            });
            this.crVideo.play();
        }
        console.log("VIDEO DATA",this.crVideo.currentTime,this.crVideo.duration);
        console.log("VIDEO STATE",this.state.crVideoPlayCount);
    }

    async recordingPlay(){
        await this.setState({
            recordingVideoPlayCount:this.state.recordingVideoPlayCount+1
        });
        this.video.play();
        console.log("RECORDING PLAY COUNT",this.state.recordingVideoPlayCount,this.video)
    }

    async recordingAudioPlay(){
        await this.setState({
            recordingAudioPlayCount:this.state.recordingAudioPlayCount+1
        });
        this.audio2.play();
        console.log("RECORDING PLAY COUNT",this.state.recordingAudioPlayCount,this.audio)
    }

    async handleSeek(){
        if(this.crVideo.currentTime!==0) {
            this.crVideo.currentTime = 0;
            this.handlePlay();
        }
    }

    toggleAudioVideo(){
        if(this.state.audioVideoSwitch==="video"){
            this.setState({
                audioVideoSwitch:"audio"
            });
            this.releaseStreamFromVideo();
        }else{
            this.setState({
                audioVideoSwitch:"video"
            });
            this.releaseStreamFromAudio();
            this.requestUserMedia();
        }
    }
    startTimer() {
        this.timer = setInterval(this.countDown, 1000);
    }

    countDown() {
        let seconds = this.state.upTime - 1;
        this.setState({upTime: seconds});
        if (seconds <= 0) {
            clearInterval(this.timer);
        }
    }

    render() {

        let countDown = (
            <div hidden={this.state.countdown<=0}>
                <h1 className={"fontCountdown"}>{this.state.countdown}</h1>
            </div>
        );
        let allowedPlayback = 2;
        if(this.state.recordingsCount === 1){
            allowedPlayback = 1;
        }

        return (
            <div>
                <div className={!this.props.practice ? "appSection bgGrey" : "appSection bgYellow"}>
                    <div className="container">
                        {
                            !this.props.practice ?
                                <InstructionModals
                                    Copyright
                                    modalOpen={this.state.modalInstruction}
                                    instructionMask={videoInstructionPN}
                                    toggleInstruction={this.handleToggleInstruction}
                                    closeClick={(active)=>{this.setState({modalInstruction: active});}}
                                />
                                : null
                        }
                        <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active,  popupSurvey: true});}} />
                        <DialogBox surveyModal app={'CopyRight'} userId={this.props.studentUser.id} active={this.state.popupSurvey} surveyBack={this.handleSurveyBack}/>
                        <div className="row">

                            <div className="appContainer copyright">

                                <div className="row">
                                    <div className="col-md-6 col-sm-6 text-center">
                                        <div style={{marginTop:60}}>
                                        {countDown}
                                        <video id="copyrightInstruction" hidden={this.state.recording || this.state.crVideoSrc==="" || this.state.countdown>0}
                                               ref={crVideo => this.crVideo = crVideo}
                                               src={this.state.crVideoSrc!=="" ? this.state.crVideoSrc : undefined}
                                               width="100%" height="auto"
                                               playsInline={true}
                                               muted={true}
                                               autoPlay={false}
                                               controls={this.state.crVideoPlayCount<= allowedPlayback}
                                               onPause={() => this.crVideoPause(true)}
                                               onPlay={()=> this.handlePlay()}
                                               onSeeked={() => this.handleSeek()}

                                        />
                                        {
                                            this.state.recording ?
                                                null
                                                :
                                                <a className="handBtn" style={{marginTop:25, display: this.state.crVideoPlayCount<=allowedPlayback ? "inline-block":"none"}} onClick={()=>this.handlePlay()}><span>Play Video</span></a>
                                        }
                                    </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6" style={this.state.showVideo?{}:{display: 'none'}}>

                                        <div hidden={this.state.audioVideoSwitch==="video"} style={{paddingTop:"35%"}}>
                                            <audio ref={audio => { this.audio = audio }}/>
                                            <audio
                                                controls={this.state.recordingAudioPlayCount<4}
                                                ref={audio2 => { this.audio2 = audio2 }}
                                                onPlay={()=>this.recordingAudioPlay()}
                                            />
                                        </div>
                                        <div hidden={this.state.isUploading || this.state.recording || this.state.recordingsCount===1} style={{position:'absolute',margin:'auto',zIndex:1,top:65, left:0, bottom:0, right:0}}><div className={"center-block text-center"}>
                                            <img src={videoMaskPN} alt={"Outline to Align Yourself in Video"} style={{minWidth:200,width:'65%'}} /></div>
                                        </div>
                                        <video
                                            id={"copyrightVidPlayback"}
                                            hidden={this.state.audioVideoSwitch === "audio"} playsInline={true}
                                            ref={video => {
                                                this.video = video
                                            }}
                                            style={{position:'relative',top:65}}
                                            width="100%"
                                            autoPlay={true}
                                            muted={true}
                                            onPlay={() => this.recordingPlay()}
                                            controls={!this.state.recording && this.state.videoSrc && this.state.videoSrc !== ""}
                                            className={this.state.recording || !this.state.videoSrc || this.state.videoSrc === "" ? "flippedVideo":""}
                                        />
                                        {
                                            this.state.recording ?

                                                <div className="rec" style={{fontSize:24, position:'absolute',bottom:-100, textAlign:'center',display:'block'}}><img style={{width:'auto',height:'22px'}} src={recButton} className="ico-xs" /> RECORDING </div>

                                                :

                                                null
                                        }
                                    </div>
                                    <div style={{marginLeft: 720, marginTop: 450}}>
                                        <div style={{float: "left", width: 30}}>
                                            <input type="checkbox" defaultChecked={true} onChange={this.handleShowVideo} id="checkHideDeleted" className="form-control" />
                                        </div>
                                        <div style={{float: "left", marginTop: 8, marginLeft: 10}}>
                                            Show my video
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
                <div className="section">
                    <div className="container">
                        <div className="row">
                            <div className="divBottomRelative tr">
                                <div className={"col-md-3 col-sm-4"}>
                                </div>
                                <div className={"col-md-6 col-sm-4 text-center"}>
                                    <div className={"center-block text-center"} >
                                {/*<a onClick={this.handleBackToMenu}className="backArrow fl"><span>Back to Home Page</span></a>*/}
                                {/*<a className={!this.state.recording ? "handBtn navbar-left":"hidden"}*/}
                                   {/*onClick={this.handleStartCopyRight}><span>Start Game</span></a>*/}
                                <a className={
                                    this.state.recordingsCount<=1 && !this.state.recording && this.state.crVideoPlayCount > 0
                                    ? "handBtn ":"hidden"}
                                   onClick={this.handleRecordVideo}>{this.state.recordingsCount === 0 && !this.state.isCounting  ? <span>Start</span> : <div>{this.state.isCounting? null:<span>Redo</span>}</div>}</a>
                                <a className={this.state.recording?"handBtn ":"hidden"} onClick={this.stopRecord}><span>Stop</span></a>
                                <a className={this.state.videoSrc || this.state.audioSrc ?"handBtn ":"hidden"} onClick={!this.state.disableSubmit ? this.submitSession : null}>{ this.state.recClick != 2 ? <span>Finish</span> : null}</a>
                                {/*{*/}
                                    {/*this.state.recording===false ?*/}
                                    {/*<a className="handBtn navbar-right" onClick={this.toggleAudioVideo}>*/}
                                        {/*<span>Switch to {this.state.audioVideoSwitch==="video"?"Audio":"Video"}</span>*/}
                                    {/*</a>*/}
                                    {/*: null*/}
                                {/*}*/}
                                    </div>
                            </div>
                                <div className={"col-md-3 col-sm-4"}>
                            <div className="fr" style={{display: '-webkit-box'}}>
                                {/*<LevelTrackerComponent*/}
                                    {/*level={this.state.bestScores ? this.state.bestScores.crLevel : "1"}*/}
                                    {/*step={this.state.bestScores ? this.state.bestScores.crScore : "1"}*/}
                                {/*/>*/}
                                <CountDownComponent time={this.state.timerTime} sessionTime={this.state.sessionTime} showTime={10}/>
                            </div>
                                </div>
                        </div>
                    </div>
                </div>
                <LoadingModal timer upTime={this.state.upTime} isUploading={this.state.isUploading}/>
            </div>
            </div>
        )

    }
}

class Tutorial extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <CopyRight studentUser={this.props.studentUser} practice={true}/>
        );
    }
}
const bindActionToProps = dispatch => {
    return {
        updateStudentAppStatus: async(results) => await dispatch(updateStudentAppsStatus(results)),
        updateStudentAccountTab:async(tabNum) => await dispatch(updateStudentAccountTab(tabNum)),
        updateAppStates:async(appStates) => await dispatch(updateAppStates(appStates))
    };
};

const mapStateToProps = state => ({
    apps:state.studentReducer.apps,
    tabNum: state.studentReducer.tabNum,
    studentUser: state.studentReducer.studentUser,
    appStates: state.studentReducer.appStates
});

export default connect(mapStateToProps,bindActionToProps)(withRouter(CopyRightComponent));



// WEBPACK FOOTER //
// ./src/StudentsComponent/CopyRight.js